export default "/img/hero/22seven-spike-integration.png"